import React from 'react';

import InnerTabs from '~/components/core/Layout/InnerTabs/InnerTabs';

import CoveredObjectsTab from './CoveredObjectsTab';
import DetailsTab from './DetailsTab';

const TABS = [
  {
    label: 'Details',
    url: 'details',
    component: DetailsTab,
  },
  {
    label: 'Covered Objects',
    url: 'covered-objects',
    component: CoveredObjectsTab,
  },
];

type GenericPolicyPageV2Props = {
  isTabActive?: boolean;
};

// The sidebar `Policy` tab is registered with `persist: true`, so this
// component stays mounted even after the user switches to another tab
// (e.g. Finances). `InnerTabs` has a fallthrough `<Redirect>` that fires
// whenever its sub-routes don't match the current URL — without the
// `isTabActive` gate it would push the URL back to `/policy`, causing the
// router "dance" when navigating away.
const GenericPolicyPageV2: React.FC<GenericPolicyPageV2Props> = ({ isTabActive = true }) => {
  if (!isTabActive) {
    return null;
  }
  // No outer CardDialog: we want the page background (gray) behind the tabs and
  // between the inner cards (Policy Details, Capacity Agreements). Each section
  // brings its own card.
  return (
    <InnerTabs
      tabs={TABS}
      // px-12 lines the tabs strip up with the 10px horizontal margin on
      // shadowedCardDivRow below; bg-slate-200 distinguishes the strip from
      // the white card background.
      tabsContainerClassName="!bg-slate-200 px-12"
    />
  );
};

export default GenericPolicyPageV2;
